// extracted by mini-css-extract-plugin
export default {"link":"eL-z","disabled":"fL-z"};